import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useAddClientEmployee = () => {
  return usePost({ url: ApiRoutesEnum.addClientEmployee });
};
